/**
 * WAGERING CONTRIBUTIONS -- ENDPOINTS
 * @description
 * [ENDPOINTS] - This are the list of endpoints for the wc module
 */
// eslint-disable-next-line
export const WAGERING = {
  GAMES_LIST: 'wagering-contribution/getGames',
  CATEGORIES_LIST: 'wagering-contribution/getCategories',
  WC_CATEGORY: 'wagering-contribution/findOne',
  WC_CATEGORY_SAVE: 'wagering-contribution/saveContributions',
}
